import CreateNewsletterContainer from "../containers/CreateNewsletterContainer";

const CreateNewsletterPage = () => {
  return (
    <CreateNewsletterContainer />
  );
};

export default CreateNewsletterPage;
